import script from "./ListItemVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./ListItemVideo.vue?vue&type=script&setup=true&lang=js"

import "./ListItemVideo.vue?vue&type=style&index=0&id=a96bc9cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a96bc9cc"]])

export default __exports__